import { render, staticRenderFns } from "./MarkerPopup.vue?vue&type=template&id=2c879d14&scoped=true&"
import script from "./MarkerPopup.vue?vue&type=script&lang=js&"
export * from "./MarkerPopup.vue?vue&type=script&lang=js&"
import style0 from "./MarkerPopup.vue?vue&type=style&index=0&id=2c879d14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c879d14",
  null
  
)

export default component.exports